import { Injectable } from '@angular/core';
import { TransactionOptionsModel } from '../models/indexdb.model';
@Injectable()
export class IndexDBService {
    dbName: string = "";
    dbVersion: number = 1;
    dataBase: IDBDatabase = null;
    constructor() {
    }

    /**
     * 打开数据库
     * evan evan 2018-11-09 
     * @param {number} version
     * @memberof IndexDBService
     */
    openDataBase(dbName: string, version: number) {
        let self = this;
        this.dbName = dbName;
        this.dbVersion = version;
        return new Promise<any>((resolve, reject) => {
            let request = indexedDB.open(dbName, version);
            request.onsuccess = (e) => {
                self.dataBase = request.result;
                resolve();
            }
            request.onerror = (e) => {
                reject("IndexedDB error: " + (<any>e.target).errorCode);
            };
            request.onupgradeneeded = function (e) {
                self.dataBase = request.result;
                if (self && self.dataBase) {
                    let storeNames = self.dataBase.objectStoreNames;
                    if (storeNames && storeNames.length > 0) {
                        for (let i = 0; i < storeNames.length; i++) {
                            self.dataBase.deleteObjectStore(storeNames[i]);
                        }
                    }
                }

                if (!self.validateStoreName("LotteryModelInfo")) {
                    // 创建数据库表
                    self.createLotteryModeInfo('LotteryModelInfo', 'lotteryCode');
                }
            };

        })
    }

    /**
     * 关闭数据库
     * evan 2018-1109
     * @memberof IndexDBService
     */
    public close(): void {
        this.dataBase.close();
    }

    // 
    /**
     * 数据库初始化处理
     * 创建配置信表及索引
     * @private
     * @memberof IndexDBService
     */
    private createLotteryModeInfo(dbname, primaryKey) {
        let store = this.dataBase.createObjectStore(dbname, { keyPath: primaryKey }
        );
    }

    // 清空本地存储数据
    public clear(storeName: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            let transaction = this.dataBase.transaction(storeName, 'readwrite');
            let store = transaction.objectStore(storeName);
            let req = store.clear();
            req.onsuccess = resolve;
            req.onerror = reject;

        });
    }
    /**
     * 添加数据 
     * 注意：使用事务来做操作比较快
     * evan 2018-11-09
     * @param {string} storeName 数据库名称
     * @param {*} data  存储的数据
     * @returns {Promise<any>}
     * @memberof IndexDBService
     */
    public insert(storeName: string, value: any, key?: any): Promise<any> {
        let self = this;
        return new Promise<any>((resolve, reject) => {
            self.validateBeforeTransaction(storeName, reject);
            let transOptions = new TransactionOptionsModel();
            transOptions.storeName = storeName;
            transOptions.dbMode = "readwrite";
            let transaction = self.createTransaction(transOptions);
            let objectStore = transaction.objectStore(storeName);
            let request = objectStore.add(value);
            transOptions.error = (e: Event) => {
                reject(e);
            };
            transOptions.completed = (e: Event) => {
                resolve({ key: key, value: value });
            };
            request.onsuccess = (evt: any) => {
                key = evt.target.result;
            }
        });
    }

    /**
     * 根据key获取数据
     * evan 2018-11-09
     * @param {string} storeName
     * @param {*} keyValue
     * @returns {Promise<any>}
     * @memberof IndexDBService
     */
    public selectByKey(storeName: string, keyValue: any): Promise<any> {
        let self = this;
        return new Promise<any>((resolve, reject) => {
            self.validateBeforeTransaction(storeName, reject);
            let transaction = self.createTransaction({
                storeName: storeName, dbMode: "readonly",
                error: (e: Event) => {
                    reject(e);
                },
                completed: (e: Event) => { }
            })
            let objectStore = transaction.objectStore(storeName),
                request: IDBRequest;

            request = objectStore.get(keyValue);
            request.onsuccess = function (event: Event) {
                resolve((<any>event.target).result);
            }
        });
    }

    /**
     * 验证数据库表名是否存在
     * evan 2018-11-09
     * @param {string} storeName
     * @returns
     * @memberof DBWrapper
     */
    validateStoreName(storeName: string) {
        return this.dataBase.objectStoreNames.contains(storeName);
    };

    /**
     * 验证使用事物之前的操作
     * evan 2018-11-09
     * @param {string} storeName
     * @param {Function} reject
     * @memberof DBWrapper
     */
    validateBeforeTransaction(storeName: string, reject: Function) {
        if (!this.dataBase) {
            reject('You need to use the createStore function to create a database before you query it!');
        }
        if (!this.validateStoreName(storeName)) {
            reject(('objectStore does not exists: ' + storeName));
        }
    }

    createTransaction(options: TransactionOptionsModel): IDBTransaction {
        let trans: IDBTransaction = this.dataBase.transaction(options.storeName, options.dbMode);
        trans.onerror = (e: Event) => {
            options.error(e);
        };
        trans.oncomplete = (e: Event) => {
            options.completed(e);
        };
        trans.onabort = (e: Event) => {
            options.abort(e);
        };
        return trans;
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/providers/indexdb.service.ts